import { EM_DASH } from "routes/custom_tables/grid/cellHelpers";

// Bare hosts ("google.com") are valid values, but an href without a scheme is
// treated as a relative link — prepend https:// so the link resolves.
const toHref = url => (/^https?:\/\//i.test(url) ? url : `https://${url}`);

export default function UrlCell({ value }) {
  return value == null || value === "" ? (
    <span className="tw:text-muted-foreground">{EM_DASH}</span>
  ) : (
    <a
      href={toHref(value)}
      target="_blank"
      rel="noopener noreferrer"
      onClick={e => e.stopPropagation()}
      className="tw:block tw:truncate tw:text-[var(--color-blue)]! tw:hover:underline"
      title={value}
    >
      {value}
    </a>
  );
}
